import React, { useState, useEffect } from 'react';

import '../styles/views/homepage.css';
import MoreInfo from '../components/MoreInfo';
import CategoryCard from '../components/CategoryCard';
import FormulaCard from '../components/FormulaCard';
import TrumpCard from '../components/TrumpCard';
import Popup from '../components/Popup';

// icon service
import icon_conditionnement from '../assets/icons/homepage_conditionnement.svg';
import icon_marketing from '../assets/icons/homepage_marketing.svg';
import icon_packaging from '../assets/icons/homepage_packaging.svg';
import icon_prod from '../assets/icons/homepage_prod.svg';
// icon formula
import icon_formula_mesure from '../assets/icons/homepage_formula_mesure.png';
import icon_formula_blanche from '../assets/icons/homepage_formula_blanche.png';
//icon qualite
import icon_qualite1 from '../assets/icons/homepage_qualite1.png';
import icon_qualite2 from '../assets/icons/homepage_qualite2.png';
import icon_qualite3 from '../assets/icons/homepage_qualite3.png';
import icon_qualite4 from '../assets/icons/homepage_qualite4.png';
//icon atouts
import icon_formulation from '../assets/icons/homepage_formulation.png';
import icon_reglementation from '../assets/icons/homepage_reglementation.png';
import icon_façonnage from '../assets/icons/homepage_conditionnement.png';
import icon_formation from '../assets/icons/homepage_formation.png';
//icon carousel
import icon_arrow_forward from '../assets/icons/arrow_forward.svg';
import icon_arrow_back from '../assets/icons/arrow_back.svg';

//video
import video_homepage from "../assets/video/video_homepage2.mp4";
import video_homepage_mobile from "../assets/video/video_homepage_mobile.mp4"

export default function Home() {

    const [isCarousel, setIsCarousel] = useState(window.innerWidth <= 900);;
    const [currentIndex, setCurrentIndex] = useState(0);
    const [forceReloadKey, setForceReloadKey] = useState(0);
    const [wichFormula, setWichFormula] = useState(0);
    const [activeButton, setActiveButton] = useState(0);
    const [currentIndexAtouts, setCurrentIndexAtouts] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1050);
    const [videoKey, setVideoKey] = useState(0);

    useEffect(() => {
        const handleResize = () => {
            const newIsMobile = window.innerWidth <= 1050;
            if (newIsMobile !== isMobile) {
                setIsMobile(newIsMobile);
                setVideoKey(prevKey => prevKey + 1);
            }
            setIsCarousel(window.innerWidth <= 1420);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [isMobile]);


    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % categories.length);
        setForceReloadKey((prevKey) => prevKey + 1);
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) =>
            (prevIndex - 1 + categories.length) % categories.length
        );
        setForceReloadKey((prevKey) => prevKey + 1);
    };

    const handleChangeFormula = (index) => {
        setWichFormula(index)
        setActiveButton(index);
    }

    const handleNextAtouts = () => {
        setCurrentIndexAtouts((prevIndex) => (prevIndex + 1) % atouts_content.length);
    };

    const handlePrevAtouts = () => {
        setCurrentIndexAtouts((prevIndex) =>
            (prevIndex - 1 + atouts_content.length) % atouts_content.length
        );
    };

    const icon_service = [
        [icon_prod, ["SMALL & LARGE", "BATCH PRODUCTION"]], [icon_packaging, ["DESIGN", "& PACKAGING"]], [icon_conditionnement, ["OPTIMAL", "PACKAGING"]], [icon_marketing, ["R&D EXPERTISE", "TO MARKETING"]]
    ];

    const categories = [
        {
            title: "Liposomes",
            subtitle: "Plant extracts Vitamins · Minerals",
            type: "liposome",
            link: "/liposomes",
        },
        {
            title: "Niosomes",
            subtitle: "Cosmetics",
            type: "niosome",
            link: "/niosomes",
        },
        {
            title: "Probiotiques & postbiotiques",
            subtitle: "VPRO® and prolipo® technologies ",
            type: "probiotique",
            link: "/probiotiques",
        },
    ];

    const formula_content = [
        ["Time saving ", "The formulations are already developed, which reduces the time needed for research and development."],
        ["Cost saving ", "No investment in production or R&D infrastructure."],
        ["Quality assurance ", "Our laboratory complies with high quality standards (HACCP, GMP)."],
        ["Flexibility ", "The ability to adapt the packaging and design to suit your brand image."],
        ["quick-to-market ", "With ready-to-use products, you can quickly launch your product range."]
    ]

    const formula_content_2 = [
        ["A one-of-a-kind product ", "Develop an original formula that reflects your vision and stands out in the market."],
        ["Adapting to specific needs ", "Target specific issues such as stress, immunity, performance..."],
        ["Selection of ingredients ", "Select innovative active ingredients or natural ingredients to meet your consumers' expectations."],
        ["Complete flexibility ", "You decide everything: dosage, dosage form (capsules, tablets, powder), flavours and much more."],
        ["Enhance your brand ", "Offer food supplements that embody your values and create a strong bond with your customers."]
    ]

    const atouts_content = [
        [
            icon_formulation,
            "formulation & sourcing",
            [
                "The development of innovative ingredients, the identification of high-performance active ingredients and tailor-made formulation. ",
                "Rigorous selection and clinical validation guaranteeing efficiency and safety.",
            ],
        ],
        [
            icon_reglementation,
            "regulations & quality",
            [
                "Management of health claims and compliance, validation of formulas and packaging, in relation with the supervisory authorities (DGCCRF, ANSES, ANSM).",
                "Regulatory monitoring to ensure quality.",
            ],
        ],
        [
            icon_façonnage,
            "Manufacturing & packaging",
            [
                "Flexible production, small and large batches. ",
                "An expanded range : phytotherapy, nutraceuticals, probiotics.",
                "A white-label catalogue and optimised distribution options.",
            ],
        ],
        [
            icon_formation,
            "Formation & communication",
            [
                "Sales support with tailored tools and courses.",
                "Direct and remote sales strategies to maximise commercial efficiency.",
            ],
        ],
    ];

    return (
        <div>
            <div className="homepage_content_intro_img">
                <video autoPlay loop muted playsInline className="homepage_video">
                    <source src={video_homepage} type="video/mp4" />
                    Votre navigateur ne supporte pas les vidéos HTML5.
                </video>
            </div>
            <div className='homepage_global-container'>
                <section className='homepage_introduction_content'>
                    <h1 className='homepage_title'><label className='orange-color font-40 padding-bottom'>our expertise</label><br /> MANUFACTURING FOOD <br />SUPPLEMENTS & premium<br /> cosmetics</h1>
                    <article className='homepage_intruction_text'>
                        Our mission is to create a wide range of food supplements and cosmetics to meet everyone's specific health, well-being and beauty needs. By focusing on the impeccable quality of our products, we guarantee optimum effectiveness and preventive solutions for everyone.
                        <br /><br />
                        We design our products around two essential pillars :
                        <ul>
                            <li><label className='orange-color bold'>Natural benefits :</label> Our formulas value the resources offered by nature.</li>
                            <li><label className='orange-color bold'>Scientific advances :</label> We incorporate relevant innovations to maximise the effectiveness of each supplement.</li>
                        </ul>
                        <br />
                        LIN offers you great production flexibility, from small to large production batches, through white label solutions or tailor-made formulas. Our expertise also covers a wide range of dosage forms, including powders, capsules and liquid formats.
                    </article>
                </section>
                <MoreInfo link="/notre-laboratoire" label={"More information"} />
                <section className='homepage_container_subtitle'>
                    <h2 className='homepage_subtitle_h2'><span className='orange-color'>360°</span> service</h2>
                    <p className='homepage_description_subtitle'>From the idea to the finished product</p>
                    <p className='homepage_subtitle_content'>
                        By following your needs and market trends, we work hand in hand to design tailor-made food supplements and cosmetics that are perfectly suited to your business goals and success.
                    </p>
                    <div className="homepage_services">
                        {icon_service.map(([icon, lines], index) => (
                            <div key={index} className="homepage_service_item">
                                <img src={icon} alt={lines.join(' ')} className="homepage_service_icon" />
                                <p className="homepage_service_text">
                                    {lines.map((line, i) => (
                                        <React.Fragment key={i}>
                                            {line}
                                            {i < lines.length - 1 && <br />}
                                        </React.Fragment>
                                    ))}
                                </p>
                            </div>
                        ))}
                    </div>
                </section>
                <div className="homepage_category_container">
                    <h2 className="homepage_category_title">
                        Our <span className="orange-color">ingredient categories</span>
                    </h2>
                    {isCarousel ? (
                        <div className="carousel">
                            <div key={forceReloadKey} className="carousel_item">
                                <CategoryCard
                                    title={categories[currentIndex].title}
                                    subtitle={categories[currentIndex].subtitle}
                                    type={categories[currentIndex].type}
                                    link={categories[currentIndex].link}
                                />
                            </div>
                            <div className='carousel_container_arrow'>
                                <img className="carousel_arrow" alt="Flèche droite" src={icon_arrow_back} onClick={handlePrev} />
                                <img className="carousel_arrow" alt="Flèche gauche" src={icon_arrow_forward} onClick={handleNext} />
                            </div>
                        </div>
                    ) : (
                        <nav className="homepage_nav_categorycard">
                            {categories.map((category, index) => (
                                <CategoryCard
                                    key={index}
                                    title={category.title}
                                    subtitle={category.subtitle}
                                    type={category.type}
                                    link={category.link}
                                />
                            ))}
                        </nav>
                    )}
                </div>
                <div className='homepage_formule_container'>
                    <h2 className="homepage_formule_title">
                        <span className="orange-color">which package </span> meets your needs ?
                    </h2>
                    {isMobile ? (
                        <div>
                            <div className="homepage_formule_container_btn_mobile">
                                <div
                                    className={`homepage_formule_btn_mobile ${activeButton === 0 ? 'active' : ''}`}
                                    onClick={() => handleChangeFormula(0)}
                                >
                                    Marque blanche
                                </div>
                                <div
                                    className={`homepage_formule_btn_mobile ${activeButton === 1 ? 'active' : ''}`}
                                    onClick={() => handleChangeFormula(1)}
                                >
                                    Sur-mesure
                                </div>
                            </div>
                            <div className="homepage_formule_bg">
                                <div className="homepage_formula_container_card">
                                    {wichFormula === 0 ? (
                                        <FormulaCard
                                            icon={icon_formula_blanche}
                                            title={"<span class='formulacard_orange_title'>white label</span> package"}
                                            subtitle={"You get access to ready-to-market, turnkey products."}
                                            content={formula_content}
                                            link={"/formule-marque-blanche"}
                                        />
                                    ) : (
                                        <FormulaCard
                                            icon={icon_formula_mesure}
                                            title={"<span class='formulacard_orange_title'>TAILOR-MADE</span> PACKAGE"}
                                            subtitle={"You develop your formulas according to your specifications."}
                                            content={formula_content_2}
                                            link={"/formule-sur-mesure"}
                                        />
                                    )}

                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="homepage_formule_bg">
                            <div className="homepage_formula_container_card">
                                <FormulaCard
                                    icon={icon_formula_blanche}
                                    title={"<span class='formulacard_orange_title'>white label</span> package"}
                                    subtitle={"You get access to ready-to-market, turnkey products."}
                                    content={formula_content}
                                    link={"/formule-marque-blanche"}
                                />
                                <FormulaCard
                                    icon={icon_formula_mesure}
                                    title={"<span class='formulacard_orange_title'>TAILOR-MADE</span> PACKAGE"}
                                    subtitle={"You develop your formulas according to your specifications."}
                                    content={formula_content_2}
                                    link={"/formule-sur-mesure"}
                                />
                            </div>
                        </div>
                    )}
                </div>
                <div className='homepage_qualite_container'>
                    <h2 className='homepage_qualite_title'><span className='orange-color'>A commitment</span> to quality <br />and eco-responsibility</h2>
                    <p className='homepage_qualite_text'>Each raw material is rigorously selected  to meet the highest standards. We are committed to guaranteeing total traceability and reducing our environmental impact, by favouring methods that respect the planet.</p>
                    <div className='homepage_icon_container'>
                        <img className='' alt="Logo certification qualité" src={icon_qualite1} />
                        <img className='' alt="Logo certification qualité HACCP" src={icon_qualite2} />
                        <img className='' alt="Logo certification qualité synadiet" src={icon_qualite3} />
                        <img className='' alt="Logo certification qualité ecocert" src={icon_qualite4} />
                    </div>
                </div>
                <div className='homepage_atouts_container'>
                    <h3 className='homepage_atouts_title'>OUR ADVANTAGES</h3>
                    <div className="homepage_atouts_box">
                        {isMobile ? (
                            <div className="carousel_container">
                                <img className="carousel_arrow" alt="Flèche droite" src={icon_arrow_back} onClick={handlePrevAtouts} />
                                <TrumpCard
                                    img={atouts_content[currentIndexAtouts][0]}
                                    title={atouts_content[currentIndexAtouts][1]}
                                    text={atouts_content[currentIndexAtouts][2]}
                                />
                                <img className="carousel_arrow" alt="Flèche gauche" src={icon_arrow_forward} onClick={handleNextAtouts} />
                            </div>
                        ) : (
                            atouts_content.map(([img, title, text], index) => (
                                <TrumpCard key={index} img={img} title={title} text={text} />
                            ))
                        )}
                    </div>
                    <MoreInfo link="*" label={"Request a quote"} />
                </div>
            </div>
        </div>
    )
}